import {assert} from 'ts-essentials';
import {StaticConfig} from './types';

export async function initializeStaticConfig() {
  assert(
    process.browser,
    'Expected initializeStaticConfig to be called on the client only',
  );

  if ('__STATIC_CONFIG__' in globalThis) {
    // Already initialized, do nothing
    return;
  }

  let staticConfig = getStaticConfig(document.body);

  if (!staticConfig) {
    const res = await fetch('/__/static_config');
    staticConfig = await res.json();
  }

  assert(
    staticConfig,
    "Expected static config to be available in the client's initial markup. " +
      'Make sure it is provided via the server rendering code and that it is valid JSON.',
  );

  window.__STATIC_CONFIG__ = staticConfig;
}

function getStaticConfig(container: Element) {
  const staticConfigElement = container.querySelector(
    '[data-tadarida-static-config]',
  );

  if (!staticConfigElement) {
    return null;
  }

  try {
    return JSON.parse(staticConfigElement.innerHTML) as StaticConfig;
  } catch (e) {
    console.error(e);

    return null;
  }
}
